var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useLiFi } from '../providers';
export const useTokenSearch = (chainId, token, enabled) => {
    const lifi = useLiFi();
    const queryClient = useQueryClient();
    const { data, isLoading } = useQuery(['token-search', chainId, token], ({ queryKey: [, chainId, token], signal }) => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield lifi.getToken(chainId, token, {
            signal,
        });
        if (data) {
            queryClient.setQueriesData(['tokens', chainId], (tokens) => {
                if (!(tokens === null || tokens === void 0 ? void 0 : tokens.some((token) => token.address === data.address))) {
                    tokens === null || tokens === void 0 ? void 0 : tokens.push(data);
                }
                return tokens;
            });
        }
        return data;
    }), {
        enabled: Boolean(chainId && token && enabled),
        retry: false,
    });
    return {
        token: data,
        isLoading,
    };
};
